import { ReactNode, Suspense, useMemo } from 'react';
import { useSelector } from 'react-redux';
import Tabs from 'components/Tabs';
import { Loader } from 'components/common/Loader';
// components
import SideBar from 'pages/SideBar';
import { Row } from 'antd';
// styles
import LayoutStyled, { Wrap } from 'pages/styles';
import { ISideBarItem } from 'types';
import { isSuperAdminSelector } from 'store/auth';
import { modulesItems } from 'lib/constants/menuItems';

export const profileWrapper = (children: ReactNode, items: ISideBarItem[]) => (
  <LayoutStyled>
    <SideBar siderItems={items} />
    <LayoutStyled>
      <Suspense fallback={null} children={children} />
    </LayoutStyled>
  </LayoutStyled>
);

export const tabsWrapper = (children: ReactNode, items) => (
  <Row>
    <Tabs items={items} />
    <Suspense
      fallback={
        <Wrap>
          <Loader loading />
        </Wrap>
      }
      children={children}
    />
  </Row>
);

const ModulesTabsWrapper = ({ children }: { children: ReactNode }) => {
  const isSuperAdmin = useSelector(isSuperAdminSelector);
  
  const filteredModulesItems = useMemo(
    () =>
      isSuperAdmin
        ? modulesItems
        : modulesItems.filter(item => item.key !== '/settings/modules/integrations'),
    [isSuperAdmin]
  );

  return (
    <Row>
      <Tabs items={filteredModulesItems} />
      <Suspense
        fallback={
          <Wrap>
            <Loader loading />
          </Wrap>
        }
        children={children}
      />
    </Row>
  );
};

export const modulesTabsWrapper = (children: ReactNode) => (
  <ModulesTabsWrapper>{children}</ModulesTabsWrapper>
);
